/* global femcare */

femcare.shared.verticalTabs = {
    /**
     * Initializes the vertical tabs component by setting up event listeners
     * and controlling the display of tab panels based on user interaction.
     */
    init: function () {
        const tabContainers = document.querySelectorAll('.vertical-tabs');

        tabContainers.forEach(container => {
            const tabButtons = container.querySelectorAll('.vertical-tabs__tab-link');
            const tabPanels = container.querySelectorAll('.vertical-tabs__tab-panel');
            const selectDropdown = container.querySelector('.vertical-tabs__selectmenu select');

            if (tabButtons) {
                tabButtons.forEach((button, tabIndex) => {
                    button.addEventListener('click', (event) => {
                        event.preventDefault();
                        femcare.shared.verticalTabs.activateTab(tabIndex, tabButtons, tabPanels);
                    });
                });
            }

            if (selectDropdown) {
                selectDropdown.addEventListener('change', (event) => {
                    const selectedTabIndex = parseInt(event.target.value, 10);
                    femcare.shared.verticalTabs.activateTab(selectedTabIndex, tabButtons, tabPanels);
                });
            }
        });
    },

    /**
     * Activates the specified tab and shows the corresponding panel.
     * @param {number} activeTabIndex - The index of the tab to activate.
     * @param {NodeList} tabButtons - The list of tab button elements.
     * @param {NodeList} tabPanels - The list of tab panel elements.
     */
    activateTab: function (activeTabIndex, tabButtons, tabPanels) {
        tabButtons.forEach((button, index) => {
            const isActive = index === activeTabIndex;
            button.setAttribute('aria-selected', isActive);
            button.classList.toggle('active', isActive);

            const panel = tabPanels[index];
            panel.hidden = !isActive;
            panel.classList.toggle('displayed', isActive);

            if (isActive) {
                panel.focus();
            }
        });
    },
};
